import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { resetAssetSidebar } from '../assets/sidebar/assetSidebarSlice.ts';

const RouteListener = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(resetAssetSidebar());
    }, [location.pathname, location.search, dispatch]);

    return null;
};

export default RouteListener;
